import Loadable from 'react-loadable';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const CreditsLinksLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "CreditsLinks" */
      './CreditsLinks.dynamic'
    ),
  loading: LoadingPageLoadable,
});
